function HelpLink(props) {
    return (
        <a className={props.className} href={`${window.support_url}${props.url}`} target="_blank" rel="noreferrer">{props.text}</a> 
    )
}
export default HelpLink;